import * as DocumentConstants from "../constants/document.constant";
import { Loading } from "../utils/helpers/constants";
import { modifyList } from "../utils/helpers/dataHelper";

const initialState = {
  instructions: [],
  instruction: {},
  instructionLoading: false,
  documentList: [],
  document: {},
  documentLoading: "",
  processDocumentLoading: "",
  docStatusLoading: {},
  docModal: false,
  processingFee: {},
  processingFeeLoading: "",
  attachDocumentLoading: "",
  attachDocument: {},
  attachDocumentList: [],
  userDocumentProcessingList: [],
  userDocumentProcessingLoading: "",
  countries: [],
  cities: [],
  countryLoading: "",
  instructionsLoading: "",
  requiredDocuments: [],
  requiredDocumentsLoading: "",
  trackingStatusList: [],
  trackingLoading: "",
};

const setLoading = (state, action) => {
  const actionLoading = { ...state.docStatusLoading };
  const { loading, id } = action.payload;
  actionLoading[id] = loading;
  return actionLoading;
};

const documentReducer = (state = initialState, action) => {
  switch (action.type) {
    case DocumentConstants.FETCH_DOCUMENT_TYPE_INSTRUCTION_REQUEST:
      return { ...state, instructionLoading: true };
    case DocumentConstants.FETCH_DOCUMENT_TYPE_INSTRUCTION_SUCCESS:
      return {
        ...state,
        instructions: action.payload,
        instructionLoading: false,
      };
    case DocumentConstants.FETCH_DOCUMENT_TYPE_INSTRUCTION_FAILURE:
      return { ...state, instructionLoading: false };

    case DocumentConstants.FETCH_DOCUMENT_LIST_REQUEST:
      return { ...state, documentLoading: Loading.FETCHING };
    case DocumentConstants.FETCH_DOCUMENT_LIST_SUCCESS:
      return {
        ...state,
        documentList: action.payload.documentProcessingList,
        documentLoading: Loading.SUCCESS,
      };
    case DocumentConstants.FETCH_DOCUMENT_LIST_FAILURE:
      return { ...state, documentLoading: Loading.FAILED };

    case DocumentConstants.FETCH_DOCUMENT_REQUEST:
      return { ...state, documentLoading: Loading.FETCHING };
    case DocumentConstants.FETCH_DOCUMENT_SUCCESS:
      return {
        ...state,
        document: action.payload,
        documentLoading: Loading.SUCCESS,
      };
    case DocumentConstants.FETCH_DOCUMENT_FAILURE:
      return { ...state, documentLoading: Loading.FAILED };

    case DocumentConstants.PROCESS_DOCUMENT_REQUEST:
      return {
        ...state,
        processDocumentLoading: Loading.FETCHING,
        docModal: false,
      };
    case DocumentConstants.PROCESS_DOCUMENT_SUCCESS:
      return {
        ...state,
        document: action.payload,
        processDocumentLoading: Loading.SUCCESS,
        docModal: true,
      };
    case DocumentConstants.PROCESS_DOCUMENT_FAILURE:
      return {
        ...state,
        processDocumentLoading: Loading.FAILED,
        docModal: false,
      };

    case DocumentConstants.DOCUMENT_APPROVAL_REQUEST:
      return { ...state, docStatusLoading: setLoading(state, action) };
    case DocumentConstants.DOCUMENT_APPROVAL_SUCCESS:
      const docList = [...state.documentList];
      const modifiedList = modifyList(
        docList,
        action.payload.id,
        "id",
        "approved"
      );
      return {
        ...state,
        documentList: modifiedList,
        docStatusLoading: setLoading(state, action),
      };
    case DocumentConstants.DOCUMENT_APPROVAL_FAILURE:
      return { ...state, docStatusLoading: setLoading(state, action) };

    case DocumentConstants.PROCESSING_FEE_REQUEST:
      return {
        ...state,
        processingFeeLoading: Loading.FETCHING,
      };
    case DocumentConstants.PROCESSING_FEE_SUCCESS:
      return {
        ...state,
        processingFee: action.payload,
        processingFeeLoading: Loading.SUCCESS,
      };
    case DocumentConstants.PROCESSING_FEE_FAILURE:
      return {
        ...state,
        processingFeeLoading: Loading.FAILED,
      };

    case DocumentConstants.ATTACH_DOCUMENT_REQUEST:
      return {
        ...state,
        attachDocumentLoading: Loading.FETCHING,
      };
    case DocumentConstants.ATTACH_DOCUMENT_SUCCESS:
      return {
        ...state,
        attachDocument: action.payload,
        attachDocumentLoading: Loading.SUCCESS,
      };
    case DocumentConstants.ATTACH_DOCUMENT_FAILURE:
      return {
        ...state,
        attachDocumentLoading: Loading.FAILED,
      };

    case DocumentConstants.FETCH_ATTACHED_DOCUMENT_REQUEST:
      return {
        ...state,
        attachDocumentLoading: Loading.FETCHING,
      };
    case DocumentConstants.FETCH_ATTACHED_DOCUMENT_SUCCESS:
      return {
        ...state,
        attachDocumentList: action.payload,
        attachDocumentLoading: Loading.SUCCESS,
      };
    case DocumentConstants.FETCH_ATTACHED_DOCUMENT_FAILURE:
      return {
        ...state,
        attachDocumentLoading: Loading.FAILED,
      };

    case DocumentConstants.FETCH_USER_DOCUMENTS_REQUEST:
      return {
        ...state,
        userDocumentProcessingLoading: Loading.FETCHING,
      };
    case DocumentConstants.FETCH_USER_DOCUMENTS_SUCCESS:
      return {
        ...state,
        userDocumentProcessingList: action.payload.documentProcessingList,
        userDocumentProcessingLoading: Loading.SUCCESS,
      };
    case DocumentConstants.FETCH_USER_DOCUMENTS_FAILURE:
      return {
        ...state,
        userDocumentProcessingLoading: Loading.FAILED,
      };
    case DocumentConstants.ALL_COUNTRIES_REQUEST:
      return {
        ...state,
        countryLoading: Loading.FETCHING,
      };
    case DocumentConstants.ALL_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.payload.data,
        countryLoading: Loading.SUCCESS,
        cities: [],
      };
    case DocumentConstants.ALL_COUNTRIES_FAILURE:
      return {
        ...state,
        countryLoading: Loading.ERROR,
      };

    case DocumentConstants.FETCH_ALL_INSTRUCTIONS_REQUEST:
      return {
        ...state,
        instructionsLoading: Loading.FETCHING,
      };
    case DocumentConstants.FETCH_ALL_INSTRUCTIONS_SUCCESS:
      return {
        ...state,
        instructions: action.payload,
        instructionsLoading: Loading.SUCCESS,
      };

    case DocumentConstants.FETCH_ALL_INSTRUCTIONS_FAILURE:
      return {
        ...state,
        instructionsLoading: Loading.ERROR,
      };

    case DocumentConstants.FETCH_REQUIRED_DOCUMENTS_REQUEST:
      return {
        ...state,
        requiredDocumentsLoading: Loading.FETCHING,
      };
    case DocumentConstants.FETCH_REQUIRED_DOCUMENTS_SUCCESS:
      return {
        ...state,
        requiredDocuments: action.payload,
        requiredDocumentsLoading: Loading.SUCCESS,
      };

    case DocumentConstants.FETCH_REQUIRED_DOCUMENTS_FAILURE:
      return {
        ...state,
        requiredDocumentsLoading: Loading.ERROR,
      };

    case DocumentConstants.UPDATE_TRACKING_STATUS_REQUEST:
      return {
        ...state,
        trackingLoading: Loading.FETCHING,
      };
    case DocumentConstants.UPDATE_TRACKING_STATUS_SUCCESS:
      return {
        ...state,
        trackingLoading: Loading.SUCCESS,
      };
    case DocumentConstants.UPDATE_TRACKING_STATUS_ERROR:
      return {
        ...state,
        trackingLoading: Loading.ERROR,
      };

    case DocumentConstants.FETCH_TRACKING_STATUS_REQUEST:
      return {
        ...state,
        trackingLoading: Loading.FETCHING,
      };
    case DocumentConstants.FETCH_TRACKING_STATUS_SUCCESS:
      return {
        ...state,
        trackingStatusList: action.payload,
        trackingLoading: Loading.SUCCESS,
      };
    case DocumentConstants.FETCH_TRACKING_STATUS_ERROR:
      return {
        ...state,
        trackingLoading: Loading.ERROR,
      };

    default:
      return state;
  }
};

export default documentReducer;
